import { DataGridLayoutGrid, List, RelationListLayout } from 'framework/list';
import useEmployeeComplianceRegistryService from '../useEmployeeComplianceRegistryService';
import {
  PoliciesDataType,
  PolicyStageBadgeField,
  ComplianceDocumentContext,
  ComplianceDocumentTypeField,
} from 'domain/shared/compliance';
import { useIsMyProfile } from 'domain/shared/employee';
import LinkToSignComplianceDocumentButton from 'domain/people/employee/compliance/shared/buttons/LinkToSignComplianceDocumentButton';
import { VersionField as PolicyVersionField } from 'framework/ui/field';
import LastComplianceDocumentSigningField from '../shared/fields/LastComplianceDocumentSigningField';
import ComplianceRegistryTimelineListSection from '../shared/ComplianceRegistryTimelineListSection';
import { DownloadFileLinkField } from 'domain/shared/artifact/field';
import { isComplianceRegistryItemNotSigned } from '../shared/complianceRegistryPortalRules';

const EmployeeComplianceRegistry = () => {
  const isMyProfile = useIsMyProfile();
  const { search } = useEmployeeComplianceRegistryService();

  return (
    <ComplianceDocumentContext>
      <List getDataMethod={search}>
        <RelationListLayout isSmallLoader={false} header="Compliance" headerVariant="h4">
          <DataGridLayoutGrid
            buttons={[
              <LinkToSignComplianceDocumentButton
                isVisible={(data: PoliciesDataType) => isComplianceRegistryItemNotSigned(data) && isMyProfile}
              />,
            ]}
            isInitialLoaderPosition
            expandable={!isMyProfile}
            expandableSection={<ComplianceRegistryTimelineListSection />}
            rowProps={{
              sxRowContainer: {
                border: 0,
                my: 0,
                borderBottom: '1px solid var(--mui-palette-TableCell-border)',
              },
              sx: {
                alignItems: 'center',
              },
            }}
          >
            <DownloadFileLinkField
              label="Name"
              source="policyPath"
              showNameSource="complianceName"
              pathSource="policyPath"
              size={3}
            />

            <ComplianceDocumentTypeField size={2.5} label="Type" source="complianceType" />

            <PolicyStageBadgeField label="State" source="isPolicyAccepted" size={3} />

            <PolicyVersionField source="policyVersion" label="Actual version" />

            <LastComplianceDocumentSigningField label="Last signing" />
          </DataGridLayoutGrid>
        </RelationListLayout>
      </List>
    </ComplianceDocumentContext>
  );
};

export default EmployeeComplianceRegistry;
